var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2903 11.9L16.0003 10L19.2903 8.1C19.7703 7.82 19.9303 7.21 19.6603 6.73L17.6603 3.27C17.3803 2.79 16.7703 2.63 16.2903 2.9L13.0003 4.8V1C13.0003 0.45 12.5503 0 12.0003 0H8.0003C7.4503 0 7.0003 0.45 7.0003 1V4.8L3.7103 2.9C3.2303 2.63 2.6203 2.79 2.3403 3.27L0.3403 6.73C0.0603 7.21 0.2303 7.82 0.7103 8.1L4.0003 10L0.7103 11.9C0.2303 12.18 0.0703 12.79 0.3403 13.27L2.3403 16.73C2.6203 17.21 3.2303 17.37 3.7103 17.1L7.0003 15.2V19C7.0003 19.55 7.4503 20 8.0003 20H12.0003C12.5503 20 13.0003 19.55 13.0003 19V15.2L16.2903 17.1C16.7703 17.38 17.3803 17.21 17.6603 16.73L19.6603 13.27C19.9403 12.79 19.7703 12.18 19.2903 11.9ZM16.4303 14.87L11.7503 12.17C11.4203 11.97 11.0003 12.21 11.0003 12.6V18H9.0003V12.6C9.0003 12.22 8.5803 11.97 8.2503 12.17L3.5703 14.87L2.5703 13.14L7.2503 10.44C7.5803 10.25 7.5803 9.77 7.2503 9.57L2.5703 6.87L3.5703 5.14L8.2503 7.84C8.5803 8.03 9.0003 7.79 9.0003 7.4V2H11.0003V7.4C11.0003 7.78 11.4203 8.03 11.7503 7.83L16.4303 5.13L17.4303 6.86L12.7503 9.56C12.4203 9.75 12.4203 10.23 12.7503 10.43L17.4303 13.13L16.4303 14.87Z",
    fill: "#74777F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyContact);
export default __webpack_public_path__ + "static/media/emergency-contact.6947c739.svg";
export { ForwardRef as ReactComponent };